import React from "react";
import { css, useTheme } from "@emotion/react";
import CloseIcon from "../../../img/butter_svgs/Close.svg?react";
import { getTokenIcon } from "../../../utils/tokenIconUtils";
import { Button } from "../../general/Button/Button";
import { Text } from "../../general/Text";
import { withIsVisible } from "../../../utils/reactUtils";
import styled from "@emotion/styled";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { Hash } from "viem";
import { getTokenTicker } from "../../../utils/tokenUtils";
import { removeTokenByTokenAddress } from "../../../utils/tokenSelectorUtils";

export interface SelectedTokenButtonProps {
  tokenAddress: Hash;
  onMouseEnter: () => void;
  onClick: () => void;
}
const SelectedTokensButton: React.FC<SelectedTokenButtonProps> = ({
  tokenAddress,
  onMouseEnter,
  onClick,
}) => {
  const theme = useTheme();
  const tokenList = useTokenListByChain();

  return (
    <Button
      buttonType="quaternary"
      text={getTokenTicker(tokenAddress, tokenList)}
      buttonCss={css`
        padding: 6px;
        border-radius: 16px;
        cursor: default;
      `}
      onClick={e => {
        //Prevent default and propagation so we don't focus the legs when we don't need to
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      onTouchStart={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onMouseDown={e => e.preventDefault()}
      onMouseEnter={onMouseEnter}
    >
      <img
        width={20}
        src={getTokenIcon(tokenAddress, tokenList)}
        alt={"Selected Token Icon"}
        style={{ borderRadius: "50%" }}
      />
      <Text textStyle="Button" size="Extra Large" color={theme.button.quaternary.text.default}>
        {getTokenTicker(tokenAddress, tokenList)}{" "}
      </Text>
      <CloseButton onClick={() => removeTokenByTokenAddress(tokenAddress)}>
        <CloseIcon width={20} />
      </CloseButton>
    </Button>
  );
};

export default withIsVisible(SelectedTokensButton);

// Sub-components

const CloseButton = styled.div(({ theme }) => {
  return {
    position: "relative",
    zIndex: 1,
    background: "none",
    border: "none",
    borderRadius: "50%",
    padding: 0,
    color: theme.theme[1200],
    height: 20,
  };
});
